import React, { useState, useEffect, useContext, useCallback } from 'react';
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { withRouter } from "../../providers/withRouter";
import { 
  Box, 
  Button, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  IconButton, 
  Collapse, 
  Typography, 
  TablePagination, 
  CircularProgress 
} from "@mui/material";
import { KeyboardArrowUp as KeyboardArrowUpIcon, KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material';
import {
  getNoVisitaAlert,
  realizadoNoVisitaAlert
} from "../../services";
import { formatoFechasEs } from '../../functions/funciones';
import FiltrosAlertasNoVisita from '../filtros/filtrosAlertasNoVisita';
import { FaCheck } from "react-icons/fa";
import { UsuarioContext } from '../../providers/userContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRecogerURLParamsFiltros, construirURLParamsFiltros } from './../../functions/parametrosURL/funcionesParamsURL';

const ExpandableRow = ({ row, onValidate, validating }) => {
    const { t } = useTranslation('common');
    const [open, setOpen] = useState(false);
    const hasProperties = row.properties && row.properties.length > 0;

    return (
        <>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCell>
                    {hasProperties && (
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => setOpen(!open)}
                        >
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    )}
                </TableCell>
                <TableCell component="th" scope="row">
                  <Link to={"/aaff/" + row.nif + "/comunidades"}>
                    {row.razonSocial}
                  </Link>
                </TableCell>
                <TableCell>{row.parent_id ? "" : row.nif}</TableCell>
                <TableCell>{formatoFechasEs(row.createdAt)}</TableCell>
                <TableCell>{row.consultorCae ? `${row.consultorCae.nombre} ${row.consultorCae.apellidos}`: ''}</TableCell>
                <TableCell>
                  <Button style={{ background: validating ? '#7bc977' : 'green', color: 'white', minWidth: '5px' }} onClick={() => onValidate(row)} disabled={validating}>
                    <FaCheck />
                  </Button>
                </TableCell>
            </TableRow>
            {hasProperties && (
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box sx={{ margin: 1 }}>
                                <Table size="small" aria-label="comunidades">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>{t('alerts.columns.community')}</TableCell>
                                            <TableCell>{t('alerts.columns.noVisitReason')}</TableCell>
                                            <TableCell>{t('alerts.columns.comment')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {row.properties.map((property) => {
                                            const hasWorkcenters = property.workcenters && property.workcenters.length > 0;
                                            const hasSales = property.sales && property.sales.length > 0 && property.sales[0]?.detailsCae?.[0];
                                            
                                            return (
                                                <React.Fragment key={property.id}>
                                                    {/* Fila de la comunidad (siempre se muestra) */}
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            <Link to={`/aaff/${row.nif}/comunidades/${property.nif}`}>
                                                                {property.razonSocial}
                                                            </Link>
                                                        </TableCell>
                                                        <TableCell>
                                                            {hasSales ? property.sales[0].detailsCae[0].observaciones : '-'}
                                                        </TableCell>
                                                        <TableCell>
                                                            {hasSales ? property.sales[0].detailsCae[0].comentarios : '-'}
                                                        </TableCell>
                                                    </TableRow>
                                                    
                                                    {/* Filas de workcenters con fondo amarillo */}
                                                    {hasWorkcenters && property.workcenters.map((workcenter, index) => {
                                                        const bgColor = index % 2 === 0 ? '#fffad6' : '#fffcea';
                                                        const workSale = workcenter.workSales?.[0];
                                                        const detailsCae = workSale?.detailsCae?.[0];
                                                        
                                                        return (
                                                            <TableRow key={`wc-${workcenter.id}`} style={{ backgroundColor: bgColor }}>
                                                                <TableCell component="th" scope="row">
                                                                    {workcenter.razonSocial}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {detailsCae?.observaciones || '-'}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {detailsCae?.comentarios || '-'}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </React.Fragment>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            )}
        </>
    );
};

const NoVisitaAlert = ({ valorTab }) => {
  const { t } = useTranslation('common');
  const user = useContext(UsuarioContext)
  const [loading, setLoading] = useState(true);
  const { filtrosIniciales, filtroOrder } = useRecogerURLParamsFiltros();
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [recargar, setRecargar] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const [validating, setValidating] = useState(false);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });
  const [primeraCarga, setPrimeraCarga] = useState(true);
  const navigate = useNavigate();
  const clearFilters = () => {
    if (user.rol === "CONSUL" && localStorage.getItem("hasReloaded") === "true") {
      setBusqueda({
        ...busqueda,
        consul_id: user.id,
      });
    } else {
      setBusqueda({});
    }

    setClearFilterActivo(true);
  };
  
  const fetchData = useCallback(async ({ offset, limit, filtros = busqueda, order, orderBy } = {}) => {
      orderBy = orderBy || filtroOrder.ordenadoPor || 'id';
      order = order || filtroOrder.orden || 'ASC';

      if (primeraCarga) {
        
        if (filtros.consul_id === undefined && user.rol === 'CONSUL') {
          filtros.consul_id = user.id;
          
        } else if (filtros.consul_id === 0) {
          delete filtros.consul_id;
        }
        setPrimeraCarga(false);
      }

      construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros, order, orderBy, valorTab);

      const payload = {
        filtros,
        params: { page: offset, limit, order, orderBy },
      };

      try {
        setLoading(true);
        const response = await getNoVisitaAlert(payload);
        const { meta, data } = response;

        setData({
          meta,
          rows: data,
        });
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
        setRecargar(false);
      }
  }, [busqueda, filtroOrder, primeraCarga, user.rol, user.id, navigate, valorTab]);

  const realizarNoVisitaAAFF = async (row) => {
    setValidating(true);
    try {
      const toastInfo = toast.info(t('suppliers.messages.validating'), { autoClose: false });
      const response = await realizadoNoVisitaAlert(row.nif)
      if (response.status === 201) {
        toast.update(toastInfo, {
          render: t('suppliers.messages.alertValidated'),
          type: toast.TYPE.SUCCESS,
          autoClose: true,
        });
        setRecargar(true);
        setLoading(true);
        fetchData({});
      } else if (response.status === 403) {
        toast.update(toastInfo, {
          render: t('suppliers.messages.alertValidationError'),
          type: toast.TYPE.ERROR,
          autoClose: true,
        });
      }else{
        toast.update(toastInfo, {
          render: t('suppliers.messages.alertValidationError'),
          type: toast.TYPE.ERROR,
          autoClose: true,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(t('suppliers.messages.alertValidationErrorShort'));
    } finally {
      setValidating(false);
    }
  };

  const filtrarDatos = (filtros) => {
    setBusqueda(filtros)
    setBusquedaActiva(true);
  };

  useEffect(() => {
    fetchData({ offset: filtrosIniciales.pagina, limit: filtrosIniciales.limite, filtros: filtrosIniciales, order: filtroOrder.orden, orderBy: filtroOrder.ordenadoPor });
  }, [recargar, busqueda, filtroOrder.orden, filtroOrder.ordenadoPor]);

  return (
    <>
      <div className="pageContent tableContainer">

        <FiltrosAlertasNoVisita onFilter={filtrarDatos} clearFilter={clearFilters} filtrosIniciales={busqueda} />
        <div className="tableWrapper">
          {loading ? (
            <CircularProgress />
          ) : (
            <Paper>
              <TableContainer>
                <Table aria-label="collapsible table">
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell>{t('alerts.columns.administrator')}</TableCell>
                      <TableCell>{t('suppliers.columns.nif')}</TableCell>
                      <TableCell>{t('alerts.columns.registrationDate')}</TableCell>
                      <TableCell>{t('alerts.columns.caeConsultant')}</TableCell>
                      <TableCell>{t('alerts.columns.notify')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.rows.map((row) => (
                      <ExpandableRow key={row.id} row={row} onValidate={realizarNoVisitaAAFF} validating={validating} />
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50]}
                component="div"
                count={data.meta.total || 0}
                rowsPerPage={data.meta.per_page || 50}
                page={data.meta.current_page ? data.meta.current_page - 1 : 0}
                onPageChange={(e, newPage) => fetchData({ offset: newPage + 1, limit: data.meta.per_page })}
                onRowsPerPageChange={(e) => {
                    const newLimit = parseInt(e.target.value, 10);
                    fetchData({ offset: 1, limit: newLimit });
                }}
              />
            </Paper>
          )}
        </div>
      </div>
    </>
  );
}

export default withRouter(NoVisitaAlert);